import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { MainAppService } from 'src/modules/app-template/services/main-app.service';
import { GuiUtils } from 'src/modules/utils/misc/gui-utils';

@Injectable({ providedIn: 'root' })
export class AuthGuard {

    app = inject(MainAppService);
    router = inject(Router);

    constructor() {
        GuiUtils.checkSingleton(this);
    }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (this.app.auth.isLoggedIn()) {
            return true;
        }
        else {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.router.navigate(['base', 'login'], { queryParams: { returnUrl: state.url }});
            return false;
        }
    }
}